import * as sharedTypes from 'src/actions/shared/sharedTypes';
import BusinessHoursReference from 'src/models/BusinessHours/BusinessHoursReference';
import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import set from 'lodash/set';

const businessHoursReferencesResource = createDocumentResource<BusinessHoursReference>({
  name: 'businessHoursReferences',
  endpoint: 'v1/orgs/:orgId/business-hours/:id/references',
  type: BusinessHoursReference,
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchSuccess(state, action) {
      state.loadingState = 'succeeded';
      set(state.value, `[${action.payload.businessHoursId}]`, action.payload.result);
    },
  },
});

const fetch: sharedTypes.AppThunk =
  (params: any) =>
  async (dispatch, getState, { gateways }) => {
    const { fetchStarted, fetchSuccess, fetchError, fetchRequestError } = businessHoursReferencesResource.actions;
    const { id: businessHoursId } = params;
    try {
      dispatch(fetchStarted({}));
      const result = await gateways.businessHoursReferences.request(params);
      dispatch(fetchSuccess({ businessHoursId, result }));
    } catch (error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    }
  };

businessHoursReferencesResource.effects.fetch = fetch;

export default businessHoursReferencesResource;
